exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line_box_30_ymXhY {\n  position: relative;\n  margin: 0 0.4rem;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border-radius: 0.16rem;\n}\n\n.box_2lf5GQKC {\n  width: 100%;\n  height: 58.666667rem;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}", ""]);

// exports
exports.locals = {
	"line_box": "line_box_30_ymXhY",
	"box": "box_2lf5GQKC"
};